import React from 'react';
import Navbar from '../components/navbar';
import ChatBot from '../components/ChatBot';

export default function ChatBotPage() {
  return (
    <div className="App">
      <Navbar />
      <ChatBot />
    </div>
  );
}
